import React from 'react';
import { useState, useEffect } from 'react';
import customHeaders, { getSpace } from '../../../../../common/headers';
import useGeneralStore from '../../../../../store/general';
import { ButtonClose, InputDinamycPlaceholder } from "@lk-gtcom/ecomlab-components";
import { TitlePage } from '../../../../../components/TitlePage/TitlePage';
import { TextPage } from '../../../../../components/TextPage/TextPage';
import { DynamicFormComponent } from '../../../../../components/DynamicFormComponent/DynamicFormComponent';
import { ModalComponent } from '../../../../../components/Modal/ModalComponent/ModalComponent';
import './ModalAddContactCRM.scss'

interface ModalAddContactCRMProps {
    isModal?: boolean
    setIsModal: (e: boolean) => void
    currentContact?: number | null
    currentCompany?: number | null
    currentContract?: number | null
    setCurrentContact?: (e: number | null) => void
    setCurrentCompany?: (e: number | null) => void
    setCurrentContract?: (e: number | null) => void
    currentDeal?: number | string | null
    setCurrentDeal?: (e: number | string | null) => void
}

const ModalAddContactCRM = ({
    isModal = false,
    setIsModal,
    currentContact,
    currentCompany = undefined,
    currentContract = undefined,
    setCurrentCompany = () => { },
    setCurrentContact = () => { },
    setCurrentContract = () => { },
    currentDeal,
    setCurrentDeal
}: ModalAddContactCRMProps) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };

    const [idContact, setIdContact] = useState(null)
    const [name, setName] = useState('')
    const [firstName, setFirstName] = useState('')
    const [surname, setSurname] = useState('')
    const [surname2, setSurname2] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')
    const [jobTitle, setJobTitle] = useState('')
    const [communication, setCommunication] = useState('')
    const [address, setAddress] = useState('')
    const [deals, setDeals] = useState([])

    const currentId = idContact ? idContact : currentContact
    const [fields, setFilds] = useState([]);

    // Получение информации о контакте по id
    const fetchGetInfoContact = (): void => {
        let url = ` https://portals.ecomru.ru/api/crm/contacts/${currentId}`

        fetch(url, { method: 'GET', headers })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(res.json() as any);
                }
            })
            .then((json) => {
                const { name, phone, email, address, position, last_name, first_name, patronymic, communication } = json
                if (name) setName(name)
                if (first_name) setFirstName(first_name)
                if (phone) setPhone(phone)
                if (email) setEmail(email)
                if (address) setAddress(address)
                if (position) setJobTitle(position)
                if (last_name) setSurname2(last_name)
                if (patronymic) setSurname(patronymic)
                if (communication) setCommunication(communication)
            })
            .catch((err) => {
                console.error(err);
            })
    };

    // Создание пустого контакта
    const fetchCreateNewContact = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contacts/`

        const body = JSON.stringify({
            company_id: currentCompany
        });

        fetch(url, { body, method: 'POST', headers })
            .then((res) => res.json())
            .then((json) => {
                setIdContact(json)
            })
            .catch((err) => console.error(err));
    };

    // Удаление контактв
    const fetchDeleteContact = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contacts/${currentId}`

        fetch(url, { method: 'DELETE', headers })
            .then((res) => res.json())
            .then((json) => {
                setIdContact(json)
            })
            .catch((err) => console.error(err));
    };

    // Добавить название контакта
    const fetchSetFirstName = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contacts/first_name`

        const body = JSON.stringify({
            company_id: currentId,
            first_name: firstName
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`first name changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить отчество
    const fetchSetSurname = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contacts/patronymic`

        const body = JSON.stringify({
            company_id: currentId,
            patronymic: surname
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`patronymic changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить фамилия
    const fetchSetSurname2 = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contacts/last_name`

        const body = JSON.stringify({
            company_id: currentId,
            last_name: surname2
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`surname changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить должность
    const fetchSetJobTitle = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contacts/position`

        const body = JSON.stringify({
            company_id: currentId,
            position: jobTitle
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`position changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить способ связи
    const fetchSetCommunication = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contacts/communication`

        const body = JSON.stringify({
            company_id: currentId,
            communication: communication
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`сommunication changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить email контакта
    const fetchSetEmail = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contacts/email`

        const body = JSON.stringify({
            company_id: currentId,
            email
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`email changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить телефон контакта
    const fetchSetPhone = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contacts/phone`

        const body = JSON.stringify({
            company_id: currentId,
            phone
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`phone changed`)
            })
            .catch((err) => console.error(err));
    };

    // Связанные сделки по контакту
    const fetchGetDeals = (): void => {
        let url = ` https://portals.ecomru.ru/api/crm/deals/contacts/${currentContact}`

        fetch(url, { method: 'GET', headers })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(res.json() as any);
                }
            })
            .then((json) => {
                setDeals(json)
            })
            .catch((err) => {
                console.error(err);
            });
    };

    // Получение доп полей контакта
    const fetchGetFieldsList = (id: number | string): void => {
        let url = ` https://portals.ecomru.ru/api/crm/contacts/additional_fields/${id}`

        fetch(url, { method: 'GET', headers })
            .then((res) => res.json())
            .then((json) => {
                if (Array.isArray(json)) {
                    setFilds(json?.map(({ name, id, type, value, possible_values }) => ({ front_name: name, data_type: type, id: id, value: value ? JSON?.parse(value) : null, possible_values: possible_values })))
                }
            })
            .catch((err) => console.error(err));
    };

    // Запись полей
    const fetchSetValueField = (id: number | string, value): void => {
        let url = ` https://portals.ecomru.ru/api/crm/contacts/additional_fields/${currentId}`

        const body = JSON.stringify({
            field_id: id,
            value: (value !== null || value !== undefined) ? JSON?.stringify(value) : null
        })

        fetch(url, { method: 'POST', headers, body })
            .then((res) => res.json())
            .then((json) => {
                // if (Array.isArray(json)) {
                //     setFilds(json)
                // }
            })
            .catch((err) => console.error(err));
    };

    // Добавить сделку в контакт
    const fetchBindDeal = () => {
        let url = ` https://portals.ecomru.ru/api/crm/deals/contact/add`

        const body = JSON.stringify({
            deal_id: currentDeal,
            contact_id: currentId
        });

        fetch(url, { body, method: 'POST', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log('Сделка добавлена к контакту')
            })
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        if (currentContact) {
            fetchGetInfoContact()
            fetchGetDeals()
            fetchGetFieldsList(currentId)
        } else {
            fetchCreateNewContact()
        }
    }, [currentContact]);

    useEffect(() => {
        if (idContact) {
            fetchGetFieldsList(idContact)
        }
    }, [idContact]);

    useEffect(() => {
        if (currentId) {
            fetchBindDeal()
        }
    }, [currentDeal, currentId]);

    const onClose = () => {
        if (!firstName) {
            fetchDeleteContact()
        }
        setCurrentContact(null)
        setCurrentCompany(null)
        setCurrentContract(null)
        if (setCurrentDeal) {
            setCurrentDeal(null)
        }
        setIsModal(false)
    }

    return (
        <ModalComponent
            title={currentContact ? 'Редактирование контакта' : 'Добавление контакта'}
            right
            style={{maxWidth: '600px'}}
            onClose={onClose}
            child={
                <div className={currentCompany ? 'modal-add-contact-CRM_company' : 'modal-add-contact-CRM'}>
                    <div className='modal-add-contact-CRM__main-content'>
                        <TitlePage
                            medium
                            title={'Основная информация'}
                        />

                        <div className='modal-add-contact-CRM__content'>
                            <InputDinamycPlaceholder
                                placeholder='Имя'
                                onChange={setFirstName}
                                changeValue={firstName}
                                onBlur={fetchSetFirstName}
                                required
                                size='s'
                            />

                            <InputDinamycPlaceholder
                                placeholder='Отчество'
                                onChange={setSurname}
                                changeValue={surname}
                                onBlur={fetchSetSurname}
                                size='s'
                            />

                            <InputDinamycPlaceholder
                                placeholder='Фамилия'
                                onChange={setSurname2}
                                changeValue={surname2}
                                onBlur={fetchSetSurname2}
                                size='s'
                            />

                            <InputDinamycPlaceholder
                                placeholder='Телефон'
                                onChange={setPhone}
                                changeValue={phone}
                                onBlur={fetchSetPhone}
                                size='s'
                            />

                            <InputDinamycPlaceholder
                                placeholder='E-mail'
                                onChange={setEmail}
                                changeValue={email}
                                onBlur={fetchSetEmail}
                                size='s'
                            />

                            <InputDinamycPlaceholder
                                placeholder='Должность'
                                onChange={setJobTitle}
                                changeValue={jobTitle}
                                onBlur={fetchSetJobTitle}
                                size='s'
                            />

                            <InputDinamycPlaceholder
                                placeholder='Способ общения (почта, WA, ТГ)'
                                onChange={setCommunication}
                                changeValue={communication}
                                onBlur={fetchSetCommunication}
                                size='s'
                            />
                        </div>

                        {fields?.length ? <>
                            <TitlePage
                                medium
                                title={'Дополнительные поля'}
                            />

                            <div className='modal-add-company-CRM__content'>
                                <DynamicFormComponent
                                    productTemporary={fields}
                                    fetchSetValue={fetchSetValueField as any}
                                />
                            </div>
                        </> : null}


                        {currentContact && <div className='modal-add-contact-CRM__related-transactions'>
                            <TitlePage
                                medium
                                title='Связанные сделки'
                            />

                            <div className='modal-add-contact-CRM__related-transactions-cards'>
                                {deals?.length
                                    ?
                                    deals?.map(({ sum, name, created_at }) => {
                                        return <div className='modal-add-contact-CRM__card-transactions'>
                                            <TextPage
                                                text={<><span style={{ color: '#888', fontSize: '12px' }}>Название: </span>{name || '-'}</>}
                                            />
                                            <TextPage
                                                text={<><span style={{ color: '#888', fontSize: '12px' }}>Сумма: </span>{sum || '-'}</>}
                                            />
                                            <TextPage
                                                text={<><span style={{ color: '#888', fontSize: '12px' }}>Дата создания: </span>{new Date(created_at).toLocaleDateString('ru-RU', {
                                                    day: '2-digit',
                                                    month: 'long',
                                                    year: '2-digit',
                                                }) || '-'}</>}
                                            />
                                        </div>
                                    })
                                    :
                                    <TextPage
                                        text={<><span style={{ color: '#888', fontSize: '12px' }}>Нет сделок</span></>}
                                    />
                                }
                            </div>
                        </div>}
                    </div>
                </div>
            }
        />
    )
}

export { ModalAddContactCRM }